<div class="radio-question">
  @if (isEditing()) {
    <div class="question-config">
      <label class="config-label">
        @if (getQuestionTypeIcon(); as iconInfo) {
          <span class="question-type-icon-wrapper">
            @if (iconInfo.iconType === 'prime') {
              <i [class]="'pi ' + iconInfo.icon" class="question-type-icon"></i>
            }
            @if (iconInfo.iconType === 'material') {
              <span class="material-symbols-outlined question-type-icon">{{ iconInfo.icon }}</span>
            }
          </span>
        }
        Question Text
      </label>
      <input
        #labelInput
        type="text"
        class="config-input label-input"
        [value]="question().labelText"
        (input)="onLabelChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter your question label here...">

      <label class="config-label">Additional Info</label>
      <input
        type="text"
        class="config-input"
        [value]="question().additionalInfo ?? ''"
        (input)="onAdditionalInfoChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter additional information">

      <label class="config-label">Helper Text</label>
      <input
        type="text"
        class="config-input"
        [value]="question().helperText ?? ''"
        (input)="onHelperTextChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter helper text">

      <label class="config-label">Options</label>
      <div class="options-list">
        @for (option of options; track $index; let i = $index) {
          <div class="option-item">
            <input
              #optionInput
              type="text"
              class="config-input option-input"
              [value]="option.text"
              (input)="onOptionChange(i, $any($event.target).value)"
              (blur)="onOptionBlur()"
              [disabled]="disabled()"
              [placeholder]="'Option ' + (i + 1)">
            <label class="custom-option-checkbox-label">
              <input
                type="checkbox"
                class="config-checkbox"
                [checked]="option.isCustomOption"
                (change)="onCustomOptionToggle(i, $any($event.target).checked)"
                [disabled]="disabled()">
              <span>Custom</span>
            </label>
            <button
              type="button"
              class="remove-option-button"
              (click)="removeOption(i)"
              [disabled]="disabled() || options.length === 1"
              aria-label="Remove option">
              <span class="material-symbols-outlined">delete_forever</span>
            </button>
          </div>
        }
        <button
          type="button"
          class="add-option-button"
          (click)="addOption()"
          [disabled]="disabled()"
          aria-label="Add option">
          <i class="pi pi-plus"></i>
          <span>Add Option</span>
        </button>
      </div>

      <div class="required-toggle-row">
        <label class="config-label">
          <span class="required-asterisk">*</span>
          Required
        </label>
        <label class="required-toggle-switch">
          <input
            type="checkbox"
            [checked]="question().isRequired"
            (change)="onRequiredToggle()"
            [disabled]="disabled()">
          <span class="toggle-slider"></span>
        </label>
      </div>
    </div>
  } @else {
    <div class="question-preview">
      <div class="question-label-wrapper">
        <label class="question-label">
          <span [innerHTML]="sanitizeHtml(question().labelText || 'Radio')"></span>
          @if (question().isRequired) {
            <span class="required-indicator">*</span>
          }
        </label>
        @if (question().additionalInfo) {
          <span class="additional-info" [innerHTML]="sanitizeHtml(question().additionalInfo)"></span>
        }
      </div>
      <div class="radio-options-wrapper">
        @for (option of getOptionsForDisplay(); track $index; let i = $index) {
          <div class="radio-option">
            <input
              type="radio"
              [id]="'radio-' + question().id + '-' + i"
              [name]="'radio-' + question().id"
              [value]="getOptionText(option)"
              [checked]="selectedOptionIndex === i"
              (change)="onRadioSelect(i)"
              [disabled]="disabled()">
            <label [for]="'radio-' + question().id + '-' + i">
              {{ getOptionText(option) || 'Option ' + (i + 1) }}
            </label>
          </div>
        }
        <!-- The self-describe box sits under the options, as it does on the applicant form. -->
        @if (selectedOptionIndex !== null && options[selectedOptionIndex]?.isCustomOption) {
          <div class="custom-option-wrapper">
            <input
              type="text"
              class="custom-option-input"
              [value]="options[selectedOptionIndex]?.customValue ?? ''"
              (input)="onCustomValueChange(selectedOptionIndex!, $any($event.target).value)"
              [disabled]="disabled()"
              placeholder="Enter your custom value...">
          </div>
        }
        @if (question().helperText) {
          <span class="helper-text">{{ question().helperText }}</span>
        }
        @if (!question().options || question().options?.length === 0) {
          <p class="no-options-message">No options available</p>
        }
      </div>
    </div>
  }
</div>

